import React from 'react';

import ExamLink from '@components/libraryV2/ExamLink';
import {
  FINRA_EXAMS,
  NASAA_EXAMS,
  INSURANCE_EXAMS,
  EDUCATION_EXAMS,
} from '@constants/exams';

import * as styles from './styles.module.scss';

const PRODUCT_CATEGORIES_MAP = {
  finra: FINRA_EXAMS,
  nasaa: NASAA_EXAMS,
  insurance: INSURANCE_EXAMS,
  education: EDUCATION_EXAMS,
};

const ExamCategoryDetailedLinks = (props) => {
  const { category } = props;
  const products = PRODUCT_CATEGORIES_MAP[category];

  return (
    <div className={styles.layout}>
      <div className={styles.category}>{category}</div>
      <div className={styles.links}>
        {products.map(({ fullName, name, product }) => {
          return (
            <ExamLink
              key={name}
              className={styles.link}
              name={name}
              product={product}
              withCard
            >
              {fullName}
            </ExamLink>
          );
        })}
      </div>
    </div>
  );
};

export default ExamCategoryDetailedLinks;
